import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import { Col, Row } from "react-bootstrap";
import { useAppSelector } from "../../../Redux/hooks";
import { boroNameByCode } from "../../../utils/boros/boros";
import { buildingCodeNameByCode } from "../../../utils/buildingCode/buildingCode";

export default function Property() {
  const property = useAppSelector((state) => state.property);
  const [hideOnMobile, setHideOnMobile] = useState(true);
  if (property.assessment === null) return null;
  if (property.dobnow === null) return null;
  let twoAddresses = false;
  if (
    property.dobnow.HouseNo !== property.assessment.housenum_lo ||
    property.dobnow.StreetName !== property.assessment.street_name
  ) {
    twoAddresses = true;
  }
  return (
    <div className="property">
      <h2>Property</h2>
      <Row>
        <Col xs={6} lg={12}>
          <dt>Address</dt>
          <dd>
            {property.assessment.housenum_lo
              ? property.assessment.housenum_lo
              : property.assessment.housenum_hi}{" "}
            {property.assessment?.street_name}
            {property.assessment.aptno && ` APT ${property.assessment.aptno}`}
            {twoAddresses && (
              <>
                <br />
                {property.dobnow.HouseNo} {property.dobnow.StreetName}
              </>
            )}
          </dd>
        </Col>
        <Col xs={6} lg={12}>
          <dt>BBL</dt>
          <dd>
            {`${boroNameByCode(property.assessment.boro)} / ${property.assessment.block} / ${property.assessment.lot} ${property.assessment.easement ? ` / ${property.assessment.easement}` : ""}`}
          </dd>
        </Col>
      </Row>
      <Row>
        <Col xs={6} lg={12}>
          <dt>Tax Lot</dt>
          <dd>
            {`${boroNameByCode(property.assessment.boro)} / ${property.dobnow.TaxBlock} / ${property.dobnow.TaxLot}`}
          </dd>
        </Col>
        <Col xs={6} lg={12}>
          <dt>Bin</dt>
          <dd>
            {property.dobnow.BIN}
            {property.dobnow.AdditionalBINsforBuilding &&
              ` (${property.dobnow.AdditionalBINsforBuilding.trim()})`}
          </dd>
        </Col>
      </Row>
      <button
        className="trigger-more"
        onClick={() => setHideOnMobile(!hideOnMobile)}
      >
        More Info{" "}
        <FontAwesomeIcon icon={hideOnMobile ? faChevronRight : faChevronDown} />
      </button>
      <dl className={hideOnMobile ? "hide-on-mobile" : ""}>
        {property.assessment.appt_boro && (
          <>
            <dt>Apportionment Lot</dt>
            <dd>
              {`${boroNameByCode(property.assessment.appt_boro)} / ${property.assessment.appt_block} / ${property.assessment.appt_lot}`}
            </dd>
          </>
        )}
        <dt>Owner</dt>
        <dd>{property.assessment?.owner}</dd>
        <dt>Building Class {` (${property.assessment.bldg_class})`}</dt>
        <dd>
          {buildingCodeNameByCode(property.assessment.bldg_class)}
          <br />
          {buildingCodeNameByCode(property.assessment.bldg_class, true)}
        </dd>
        <dt>Zoning</dt>
        <dd>{property.assessment.zoning}</dd>
      </dl>
    </div>
  );
}
